import {Flag, Tooltip} from 'platform/components';
import {Box, HStack} from 'platform/foundation-tw';

import {isNil} from 'ramda';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getItemTooltipProps} from '../../utils/getItemTooltipProps';
import {getTooltipProps} from '../../utils/getTooltipProps';

// API shape: row[key].value is an array of these
type TagValue = {
  label: string;
  style?: {flagColor?: string; flagSubtle?: boolean};
} | null;

type TagCellRendererProps = CellRendererProps<Array<TagValue> | TagValue> & {
  getTooltipProps?: TooltipGetter;
};

export function TagCellRenderer(props: TagCellRendererProps) {
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);

  if (isNil(props.value)) {
    return null;
  }

  if (!Array.isArray(props.value)) {
    const singleValue = props.value as TagValue;
    if (isNil(singleValue)) {
      return null;
    }
    return (
      <Tooltip {...tooltipProps}>
        <Flag
          colorScheme={singleValue.style?.flagColor as never}
          isSubtle={singleValue.style?.flagSubtle ?? false}
          label={singleValue.label}
          data-testid={`tag-cell-renderer-${singleValue.label}`}
        />
      </Tooltip>
    );
  }

  return (
    <Box paddingVertical={1} paddingRight={1}>
      <HStack spacing={1} wrap={props.column?.wrapText}>
        {props.value.map((item, index) => {
          if (isNil(item)) {
            return null;
          }
          return (
            <Tooltip {...getItemTooltipProps(index, tooltipProps)} key={index}>
              <Flag
                colorScheme={item.style?.flagColor as never}
                isSubtle={item.style?.flagSubtle ?? false}
                label={item.label}
                data-testid={`tag-cell-renderer-${item.label}`}
              />
            </Tooltip>
          );
        })}
      </HStack>
    </Box>
  );
}
